import React from "react";
import axios from "axios";

function ManagerBusView(props) {
  const { tapes, setBus, ads, reload, setReload } = props;
  const ongoing = [];
  const previous = [];
  tapes.forEach((cur, index) => {
    const ad = ads.find(
      (el) => cur.campaignId === el.campaignId && cur.format === el.format
    );
    const line = (
      <div className="bus-line" key={index}>
        {cur.format +
          " " +
          cur.client +
          (ad ? " - viikot " + ad.start + "-" + ad.end : "")}
        {!cur.removed ? (
          <div
            key="delete-icon"
            className={"delete-icon"}
            onClick={(event) => {
              event.preventDefault();
              if (
                window.confirm(
                  "Merkitse tämä teippaus poistetuksi\nOletko varma?"
                )
              ) {
                axios
                  .post(process.env.REACT_APP_BACKEND_URL + "/updateTaping", {
                    ...cur,
                    removed: "X",
                  })
                  .then((res) => {
                    setReload(reload + 1);
                  });
              }
            }}
          >
            {"Poista"}
          </div>
        ) : (
          ""
        )}
      </div>
    );
    if (cur.removed === "X") previous.push(line);
    else ongoing.push(line);
  });
  return (
    <div>
      <button
        className="back-button"
        onClick={() => {
          setBus(undefined);
        }}
      >
        Takaisin Bussilistaan
      </button>
      <br />
      <button
        className="bussitutka-button"
        onClick={() => {
          window.open(
            `https://bussitutka.fi/${
              "vehicle?number=" + tapes[0].busNumber + "&type=bus&operator=18"
            }`,
            "_blank"
          );
        }}
      >
        Bussitutka
      </button>
      <h3 className="campaign-title">
        {"Bussin " + tapes[0].busNumber + " teipatut mainokset"}
      </h3>
      <div className="bus-lines-list">{ongoing}</div>

      <h3 className="campaign-title">
        {"Bussin " + tapes[0].busNumber + " jo poistetut mainokset"}
      </h3>
      <div className="bus-lines-list">{previous}</div>
    </div>
  );
}

export default ManagerBusView;
